export default "__VITE_ASSET__Bn0ba2_t__"